import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './DocumentosPed.css'
import brasao from '../../assets/brasilNav.png'

const DocumentosPed = () => {
    const [processo, setProcesso] = useState({ dataCriacao: '' })

    useEffect(() => {
        const id = window.location.pathname.slice(21)
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .catch(error => {
                alert(error.response)
            })
    }, [])

    const redirect = (url) => {
        window.location = url
    }

    const Anexo = () => {
        if (processo.anexos && processo.anexos.length > 0) {
            return processo.anexos.map((anexo, index) => {
                console.log(anexo)
                return {
                    component: (
                        <div key={index} className="documentosPedBody">
                            <div className="documentosPedBodyElement">{anexo.user}</div>
                            <div className="documentosPedBodyElement">{anexo.documento || anexo.tipoAnexo}</div>
                            <div className="documentosPedBodyElement">{anexo.dataCriacao.slice(0, 10)}</div>
                            <div className="documentosPedBodyElement">
                                <a href={anexo.url}>
                                    <i className="bi bi-folder-symlink iAbrirProcesso"></i>
                                </a>
                            </div>
                        </div>
                    ),
                    dataCriacao: anexo.dataCriacao,
                }
            })
        }
        return []
    }

    const Instrutor = () => {
        if (processo.membros && processo.membros.instrutor) {
            return [{
                component: (
                    <div className="documentosPedBody">
                        <div className="documentosPedBodyElement">{processo.membros.userCreateI}</div>
                        <div className="documentosPedBodyElement">Portaria Nº {processo.membros.portaria} - Instrutor</div>
                        <div className="documentosPedBodyElement">{processo.membros.dateI.slice(0, 10)}</div>
                        <div className="documentosPedBodyElement">
                            <a href={`/etica/instrutorView/${processo._id}`}>
                                <i className="bi bi-folder-symlink iAbrirProcesso"></i>
                            </a>
                        </div>
                    </div>
                ),
                dataCriacao: processo.membros.dateI,
            }]
        }
        return []
    }

    const RelatorRevisor = () => {
        if (processo.membros && processo.membros.relator) {
            return [{
                component: (
                    <div className="documentosPedBody">
                        <div className="documentosPedBodyElement">{processo.membros.userCreateRr}</div>
                        <div className="documentosPedBodyElement">Despacho Relator/Revisor</div>
                        <div className="documentosPedBodyElement">{processo.membros.dateRr.slice(0, 10)}</div>
                        <div className="documentosPedBodyElement">
                            <a href={`/etica/relatorRevisorView/${processo._id}`}>
                                <i className="bi bi-folder-symlink iAbrirProcesso"></i>
                            </a>
                        </div>
                    </div>
                ),
                dataCriacao: processo.membros.dateRr,
            }]
        }
        return []
    }

    const Sorted = () => {
        const parseDate = (dateString) => {
            const [day, month, year] = dateString.split('/').map(Number)
            return new Date(year, month - 1, day)
        }

        let total = [...Anexo(), ...Instrutor(), ...RelatorRevisor()]

        total.sort((a, b) => parseDate(a.dataCriacao) - parseDate(b.dataCriacao))

        return total.map(item => item.component)
    }

    const BotaoRr = () => {
        if (processo.membros && !processo.membros.relator) {
            return <button className="documentosPedButtons" onClick={e => redirect(`/etica/relatorRevisor/${processo._id}`)}>DESPACHO - RELATOR/REVISOR</button>
        }
    }

    const BotaoI = () => {
        if (processo.membros && !processo.membros.instrutor) {
            return <button className="documentosPedButtons" onClick={e => redirect(`/etica/instrutor/${processo._id}`)}>PORTARIA - INSTRUTOR</button>
        }
    }

    const BotaoAnexo = () => {
        return <button className="documentosPedButtons" onClick={e => redirect(`/etica/novoAnexo/${processo._id}`)}>ANEXAR DOCUMENTO</button>
    }

    const BotaoImpressao = () => {
        return <button className="documentosPedButtons" onClick={e => redirect(`/etica/impressao/${processo._id}`)}>IMPRIMIR PROCESSO</button>
    }

    return (
        <React.Fragment>
            <img src={brasao} alt="Brasil" className='brasaoPed' />
            <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
            <div className="documentosPedNumero">
                PED Nº <span className='spanDocumentosPedNumero'>{processo.numeroPed}</span>
            </div>
            <div className="overFlow">
                <div className="documentosPedHeader">
                    <div className="documentosPedHeaderElement">USUÁRIO</div>
                    <div className="documentosPedHeaderElement">DOCUMENTO</div>
                    <div className="documentosPedHeaderElement">DATA DE CRIAÇÃO</div>
                    <div className="documentosPedHeaderElement">ABRIR OU EDITAR</div>
                </div>
                <div className="documentosPedBody">
                    <div className="documentosPedBodyElement">{processo.criador}</div>
                    <div className="documentosPedBodyElement">Capa do Processo</div>
                    <div className="documentosPedBodyElement">{processo.dataCriacao.slice(0, 10)}</div>
                    <div className="documentosPedBodyElement">
                        <a href={`/etica/capaPed/${processo._id}`}>
                            <i className="bi bi-folder-symlink iAbrirProcesso"></i>
                        </a>
                    </div>
                </div>
                {Sorted()}
            </div>
            <div className="documentosPedFlexBotoes">
                {BotaoI()}
                {BotaoAnexo()}
                {BotaoRr()}
            </div>
            {BotaoImpressao()}
        </React.Fragment>
    )
}

export default DocumentosPed
